import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoChipTypes,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {useAuthState} from "../../context/AuthContext";
import {stringIsEmpty} from "../../util/VariableChecker";
import {addFiltersToUrl} from "../../util/FiltersHelper";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {LoanInstallmentsService} from "../../serverService/loanInstallments/LoanInstallmentsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function LoanInstallments() {

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1);
    const size = 20

    const navigate = useNavigate()

    const [groupName, setGroupName] = useState(searchParam.get("group-name") || "");
    const [groupCode, setGroupCode] = useState(searchParam.get("group-code") || "")
    const [accountCode, setAccountCode] = useState(searchParam.get("account-code") || "");
    const [payStatus, setPayStatus] = useState(searchParam.get("status") || "");
    const [endDate, setEndDate] = useState(searchParam.get("end-date") || "")


    const filterPayStatus = useDebounce(payStatus, 300)
    const filterGroupName = useDebounce(groupName, 300)
    const filterGroupCode = useDebounce(groupCode, 300)
    const filterAccountCode = useDebounce(accountCode, 300)
    const filterEndDate = useDebounce(endDate, 300)

    const [tableLoading, setTableLoading] = useState(true)
    const [installments, setInstallments] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const {fundID} = useAuthState()

    const service = new LoanInstallmentsService()


    useEffect(() => {
        if (
            typeof filterGroupName !== "undefined" &&
            typeof filterGroupCode !== 'undefined' &&
            typeof filterPayStatus !== 'undefined' &&
            typeof filterEndDate !== 'undefined' &&
            typeof filterAccountCode !== 'undefined'
        ) {
            getDataFromServer()
            prepareFiltersParam()
        }
    }, [
        filterGroupName,
        filterGroupCode,
        filterPayStatus,
        filterAccountCode,
        filterEndDate,
        page,
        fundID
    ]);

    function prepareTableItem(
        number, id, firstName, lastName, nationalCode,
        phoneNumber, numberOfInstallment, amount, amountPayable,
        remindAmountOfLoan, remindAmountOfInstallment, dateOfPayment,
        paidAt, amountPaid, paid, paidByManger, paidByMember, status) {
        return {
            id,
            number,
            installmentID: id,
            fullName: `${firstName} ${lastName}`,
            nationalCode: nationalCode,
            amount: convertCurrencyFormatPositiveNegative(amountPayable),
            amountPaid: convertCurrencyFormatPositiveNegative(amountPaid),
            remindAmountOfLoan: convertCurrencyFormatPositiveNegative(remindAmountOfLoan),
            DueDate: convertUniversalDateTimeToPersianDateTime(dateOfPayment),
            remindAmountOfInstallment: convertCurrencyFormatPositiveNegative(remindAmountOfInstallment),
            paidAt: convertUniversalDateTimeToPersianDateTime(paidAt),
            paidByType: paidByManger ? "مدیر" : paidByMember ? "کاربر" : remindAmountOfInstallment === 0 ? "خودکار سیستم" : "-",
            paidBy: paidByManger ? paidByManger : paidByMember ? paidByMember : remindAmountOfInstallment === 0 ? "خودکار سیستم" : "-",
            paid: status || remindAmountOfInstallment === 0 ?
                <RaikoCustomSimpleChip
                    title={"پرداخت شده"}
                    type={RaikoChipTypes.success}
                /> :
                <RaikoCustomSimpleChip
                    title={"پرداخت نشده"}
                    type={RaikoChipTypes.error}
                />
        }
    }

    function getDataFromServer() {
        setTableLoading(true)

        service.getInstallments(
            fundID,
            page - 1,
            size,
            filterGroupName,
            filterGroupCode,
            filterPayStatus,
            filterAccountCode,
            filterEndDate
        )
            .then(response => {

                setTotalItems(response.numberOfItems)
                setPageCount(response.totalPage)

                setInstallments([])
                response.data.map((item, index) => {
                    setInstallments(prev => [
                        ...prev,
                        prepareTableItem(
                            ((page - 1) * size) + index + 1,
                            item.id,
                            item.firstName,
                            item.lastName,
                            item.nationalCode,
                            item.phoneNumber,
                            item.numberOfInstallment,
                            item.amount,
                            item.amountPayable,
                            item.remindAmountOfLoan,
                            item.remindAmountOfInstallment,
                            item.dateOfPayment,
                            item.paidAt,
                            item.amountPaid,
                            item.paid,
                            item.paidByManger,
                            item.paidByMember,
                            item.status
                        )
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareFiltersParam() {
        const filters = []

        if (page && page > 1)
            filters.push(`page=${page}`)

        if (!stringIsEmpty(filterGroupName))
            filters.push(`group-name=${filterGroupName}`)

        if (!stringIsEmpty(filterGroupCode))
            filters.push(`group-code=${groupCode}`)

        if (!stringIsEmpty(filterPayStatus) && filterPayStatus !== 'ALL')
            filters.push(`status=${payStatus}`)

        if (!stringIsEmpty(filterAccountCode))
            filters.push(`account-code=${accountCode}`)

        if (!stringIsEmpty(filterEndDate))
            filters.push(`end-date=${filterEndDate}`)

        navigate(addFiltersToUrl(filters))
    }

    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }

    function handleDeleteAllFilters() {
        setGroupName("")
        setGroupCode("")
        setPayStatus("")
        setEndDate("")
        setAccountCode("")
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(RouteHelper.InstallmentsList.name, ""),
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اقساط"}
                            amount={totalItems}
                            hasCreateNewItem
                            createNewItemTitle={"پرداخت اقساط"}
                            handleCreateNewItem={_ => {
                                navigate(RouteHelper.PayInstallments.globalUrl)
                            }}
                        />
                        <RaikoTableSearchContainer
                            hasFilter={true}
                            labelText={"نام گروه"}
                            placeHolder={"عبارت مورد نظر را وارد نمایید"}
                            setValue={setGroupName}
                            value={groupName}
                            handleDeleteAllFilters={handleDeleteAllFilters}
                            filterStatus={
                                !stringIsEmpty(filterGroupCode) ||
                                !stringIsEmpty(filterAccountCode) ||
                                (!stringIsEmpty(payStatus) && payStatus !== "ALL") ||
                                !stringIsEmpty(filterEndDate)
                            }
                        >
                            <RaikoGridOneColumn>
                                <RaikoNumberInputOutlined
                                    labelText={"کد گروه"}
                                    value={groupCode}
                                    setValue={setGroupCode}/>

                                <RaikoNumberInputOutlined
                                    labelText={"شناسه حساب"}
                                    value={accountCode}
                                    setValue={setAccountCode}/>

                                <RaikoCustomSelect
                                    labelText={"وضعیت پرداخت اقساط"}
                                    value={payStatus}
                                    setValue={setPayStatus}
                                    items={[
                                        raikoCustomSelectItemGenerator("ALL", "همه"),
                                        raikoCustomSelectItemGenerator("PAID", "پرداخت شده"),
                                        raikoCustomSelectItemGenerator("UN_PAID", "پرداخت نشده"),
                                    ]}/>

                                <RaikoDatePicker
                                    label={"تا تاریخ"}
                                    date={endDate}
                                    setDate={setEndDate}/>


                            </RaikoGridOneColumn>

                        </RaikoTableSearchContainer>
                        <RaikoCustomTable
                            header={header}
                            data={installments}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            newPage={page}
                            handlePaginationChange={handleChangePagination}
                            // rowClicked={handleShowDetail}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}

const header = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'installmentID',
        label: 'شناسه قسط',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'DueDate',
        label: 'سررسید',
        align: 'right',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },

    {
        id: 'amountPaid',
        label: 'پرداخت شده (ریال)',
        align: 'right',
    },
    {
        id: 'remindAmountOfInstallment',
        label: 'باقی مانده قسط',
        align: 'right',
    },
    {
        id: 'remindAmountOfLoan',
        label: 'باقی مانده وام (ریال)',
        align: 'right',
    },


    {
        id: 'paidAt',
        label: 'تاریخ پرداخت',
        align: 'right',
    },
    {
        id: 'paidBy',
        label: 'پرداخت کننده',
        align: 'right',
    },
    {
        id: 'paid',
        label: 'وضعیت',
        align: 'right',
    },
]
